export const productTypes = {
  CHAS_FOUNDATION: 'fdcb5551-f374-eb11-a812-000d3a4c18a3'
}
